import React from "react";
import {
  CTable,
  CTableHead,
  CTableRow,
  CTableHeaderCell,
  CTableBody,
} from "@coreui/react";
import { DownArrowIcon } from "../../../assets/images";
import FuelSupplierTableItem from "./FuelSupplierTableItem";
import NoDataTableItem from "../../../components/AdminDashboard/NoDataTableItem";
import { FUEL_SUPPLIER_ACTIONS } from "../../../constants/FuelSupplierConstants";

interface IFuelSupplierTableProps {
  dispatchReducer: React.Dispatch<any>;
  fuelSuppliers: any[];
  colNames: string[];
  colValues: any[];
  sortOrder?: 'asc' | 'desc';
}

const FuelSupplierTable = ({
  dispatchReducer,
  fuelSuppliers,
  colNames,
  colValues,
  sortOrder = 'asc',
}: IFuelSupplierTableProps) => {
  const sortByLocale = (key: string) => {
    dispatchReducer({ type: FUEL_SUPPLIER_ACTIONS.SORT, key: key });
  };

  return (
    <CTable className="fuelSupplierTable" borderless hover>
      <CTableHead>
        <CTableRow>
          {!!colNames &&
            colNames.length !== 0 &&
            Array.isArray(colNames) &&
            colNames.map((col_name, index) => (
              <CTableHeaderCell
                key={`fuelSupplierTableHeader${index}`}
                scope="col"
                className={`CathaySansLt px-0 appendixHeader ${col_name === "Airport IATA" ? "clickable" : ""}`}
                onClick={() => {
                  if (col_name === "Airport IATA") {
                    sortByLocale(`${col_name}`);
                  }
                }}
              >
                {col_name}
                {col_name === "Airport IATA" && (
                  <DownArrowIcon
                    height={12}
                    width={12}
                    style={{
                      transform: sortOrder === 'desc' ? 'rotate(180deg)' : 'rotate(0deg)',
                      transition: 'transform 0.2s ease'
                    }}
                  />
                )}
              </CTableHeaderCell>
            ))}
        </CTableRow>
      </CTableHead>
      <CTableBody>
        {!!fuelSuppliers &&
        fuelSuppliers.length !== 0 &&
        Array.isArray(fuelSuppliers) ? (
          fuelSuppliers.map((fuelSupplier, index) => {
            return (
              <FuelSupplierTableItem
                key={`FuelSupplierTableItem_${index}`}
                dispatchReducer={dispatchReducer}
                fuelSupplier={fuelSupplier}
                colValues={colValues[index]}
              />
            );
          })
        ) : (
          <NoDataTableItem
            colSpan={6}
            message={"There is no fuel supplier data."}
          />
        )}
      </CTableBody>
    </CTable>
  );
};

export default FuelSupplierTable;
